export class NotificationTemplate {
	id: string;
	template_name: string;
	notification_description: string;
	email_subject: string;
	email_body: string;
	used_on_count: number;

    clear() : void {
        this.id="";
        this.template_name="";
		this.notification_description = "";
		this.email_subject = "";
		this.email_body = "";
		this.used_on_count = 0;
    }
}
